import axios from 'axios'
import Cookies from 'js-cookie'
// import {instance} from "../axios-instance";
// import { loginMethods } from './sender/login.js';
import {
  useRoute,
  createRouter as _createRouter,
  createMemoryHistory,
  createWebHistory
} from 'vue-router'
import { useAuthStore } from '@store/pinia/auth.store'

let lastCheck = 0
let isAuth = false
// const mainFooter = () => import('@pages/main/footer.vue')
// const topLine = () => import('@pages/main/topLine/index.vue')
const checkToken = function () {
  const dateTime = new Date() - 0
  return new Promise((resolve, reject) => {
    if (Math.abs(lastCheck - dateTime) < 10 * 1000) {
      if (isAuth) {
        resolve()
      } else {
        reject()
      }
    } else {
      const query = new URLSearchParams(window.location.search)
      let token = query.get('token')
      if (!token && localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      if (token) {
        // loginMethods.checkToken(token).then(() => {
        //   isAuth = true;
        //   resolve()
        // }).catch(() => {
        //   reject()
        // })
      } else {
        reject()
      }
    }
  })
}

const requireLoggedIn = () => {
  const auth = useAuthStore()
  const loggedIn = Boolean(
    auth?.token || auth?.user || auth?.isAuth || auth?.isLoggedIn
  )
  if (!loggedIn) {
    return { path: '/' }
  }
  return true
}

const routes = [
  {
    path: '/',
    name: 'Main',
    props: {
      body: route => ({
        local: false
      })
    },
    components: {
      body: () => import('@pages/Main.vue')
    }
  },
  {
    path: '/local/',
    name: 'MainWithProps',
    props: {
      body: route => ({
        local: true
      })
    },
    components: {
      body: () => import('@pages/Main.vue')
    }
  },
  {
    path: '/telegram-login',
    name: 'telegram-login',
    components: {
      body: () => import('@pages/TelegramLogin.vue')
    }
  },
  {
    path: '/system/',
    name: 'system-local',
    props: {
      body: route => ({
        system: true
      })
    },
    beforeEnter: requireLoggedIn,
    components: {
      body: () => import('@pages/System.vue')
    }
  },
  {
    path: '/tournaments/',
    name: 'tournaments',
    beforeEnter: requireLoggedIn,
    components: {
      body: () => import('@pages/Tournaments.vue')
    }
  },
  {
    path: '/clients/',
    name: 'clients',
    beforeEnter: requireLoggedIn,
    components: {
      body: () => import('@pages/Clients.vue')
    }
  },
  {
    path: '/clients/:pairKey',
    name: 'client-edit',
    beforeEnter: requireLoggedIn,
    components: {
      body: () => import('@pages/ClientEdit.vue')
    }
  },

  {
    path: '/search/:id',
    name: 'search',

    components: {
      body: () => import('@pages/Search.vue')
    }
  },
  {
    path: '/competitions/:id',
    name: 'competitions',

    components: {
      body: () => import('@pages/Search.vue')
    }
  },
  {
    path: '/local/competitions/:id',
    name: 'competitions-local',
    props: {
      body: route => ({
        local: true
      })
    },
    components: {
      body: () => import('@pages/Search.vue')
    }
  },
  {
    path: '/scrutener/:id',
    name: 'Scrutener',

    components: {
      body: () => import('@pages/scrutener/Results.vue')
    }
  },
  {
    path: '/bookings/',
    name: 'bookings',
    beforeEnter: requireLoggedIn,
    components: {
      body: () => import('@pages/Bookings.vue')
    }
  }
]

export function createRouter() {
  console.info('lalalal')
  console.info('lalalal')
  console.info('lalalal')
  console.info('lalalal')
  return _createRouter({
    // use appropriate history implementation for server/client
    // import.meta.env.SSR is injected by Vite.
    history: import.meta.env.SSR
      ? createMemoryHistory('/')
      : createWebHistory('/'),
    routes
  })
}

export default routes
